import { analytics } from "@rshbintech.dboul/analytics";

export const enum AnalyticsCategoryName {
  SPECIAL_OFFER = "placement",
}

type SendAnalyticsParams = {
  eventCategoryName: AnalyticsCategoryName;
  eventActionName: string;
  eventValueText?: string;
  inn?: string;
};

export const sendAnalytics = (params: SendAnalyticsParams) => {
  const {
    eventCategoryName,
    eventActionName,
    eventValueText = null,
    inn = null,
  } = params;

  analytics.sendEvent({
    ...(inn ? { customer: { ids: { sbcustomerID: inn } } } : {}),
    customerAction: {
      customFields: {
        eventcategory: eventCategoryName,
        eventaction: eventActionName,
        ...(eventValueText ? { eventvaluetext: eventValueText } : {}),
        ...(inn ? { sbcustomerID: inn } : {}),
      },
    },
  });
};
